import { Collapse, List, ListItem, ListItemText, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Fragment, memo, ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback } from 'react';
import { DisabledCardMenu } from 'shell/view-models/disabled-menu';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: `${theme.spacing(4)} !important`,
    },
    nestedIcon: {
      minWidth: 'auto !important',
      paddingRight: theme.spacing(2),
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
    colorItems: {
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
  })
);

interface CardCollapseProps {
  onSubItemClick?: () => void;
  link: string;
  active: DisabledCardMenu;
}

const CardCollapseComponent = ({
  onSubItemClick,
  link,
  active,
}: CardCollapseProps): ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  return (
    <Fragment>
      <ListItem
        button
        key="Carta d'identità"
        onClick={() => {
          handleClick();
        }}
        sx={{ pl: 6 }}
        className={classes.colorItems}
      >
        <ListItemText
          key="cartaidentita"
          className={classes.colorItems}
          primary="Carta d'identità "
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List key="list" component="div" disablePadding>
          {active.rilascioCarta ? (
            <Link
              key={`${link}/rilascio-carta`}
              to={`${link}/rilascio-carta`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Rilascio Carta d'identità" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.ristampaCid ? (
            <Link
              key={`${link}/ristampa-carta`}
              to={`${link}/ristampa-carta`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Stampa busta" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.registrazioneCarta ? (
            <Link
              key={`${link}/registrazione-carta`}
              to={`${link}/registrazione-carta`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Registrazione Carta" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.annullamentoCarta ? (
            <Link
              key={`${link}/annullamento-carta`}
              to={`${link}/annullamento-carta`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Annullamento Carta" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.gestioneLotti ? (
            <Link
              key={`${link}/gestione-lotti`}
              to={`${link}/gestione-lotti`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Gestione Lotti" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.recuperoCartelliniCie ? (
            <Link key={`${link}/recupero-cie`} to={`${link}/recupero-cie`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Recupero cartellini CIE" />
              </ListItem>
            </Link>
          ) : undefined}
        </List>
      </Collapse>
    </Fragment>
  );
};

CardCollapseComponent.displayName = 'Card Collapse Item';

const CardCollapse = memo(CardCollapseComponent);

export default CardCollapse;
